<!-- eslint-disable max-len -->

<route>
    {
      "meta": {
        "requireAdmin": true,
        "customSite": true
      }
    }
    </route>
<template>
  <div class="p-5 w-full relative">
    <!-- -------------------------------------------imported components section--------------------------  -->
    <NewPipelineModal />
    <SegmentListModal />
    <new-segment-modal />
    <pipeline-edit-modal
      :editModal="editModal"
      :closeModal="() => (editModal = false)"
      :oldName="currentPipelineDetails"
    />
    <delete-modal
      title="Remove Confirmation"
      message="Are you sure you want to delete pipeline?"
      :callback="deleteConfirmed"
      :openModal="deleteModal"
      :handlePopups="() => (deleteModal = false)"
    />
    <!-- -------------------------------------------header tab section--------------------------  -->
    <div class="flex max-w-xs absolute -mt-20 ml-40">
      <select
        class="select select-bordered w-full"
        required
        v-model="currentPipelineDetails"
        @change="
          ($event) => {
            this.$store.commit('SET_CURRENT_PIPELINE', $event.target.value);
            this.$store.dispatch('getPipelineDetails');
          }
        "
      >
        <option disabled="disabled" value="">Select pipeline</option>
        <option
          v-for="(item, index) in pipelinesList"
          :value="JSON.stringify(item)"
          :key="index"
        >
          {{ item.pipeline_name }}
        </option>
      </select>
      <button
        class="
          btn btn-square btn-outline
          ml-5
          hover:bg-gray-200
          border-gray-600
        "
      >
        <font-awesome-icon
          class="reaction text-gray-600"
          size="lg"
          :icon="['far', 'edit']"
          @click="() => (editModal = true)"
        />
      </button>
      <button
        class="
          btn btn-square btn-outline
          ml-5
          hover:bg-gray-200
          border-gray-600
        "
      >
        <font-awesome-icon
          class="reaction text-gray-600 "
          size="lg"
          :icon="['far', 'trash-alt']"
          @click="()=>deleteModal= true"
        />
      </button>

      <div
        :class="[
          'flex ml-5 pr-8',
          pipelineLimit <= pipelinesList.length ? 'tooltip tooltip-right' : '',
        ]"
        data-tip="Pipeline limit reached"
      >
        <button
          :disabled="pipelineLimit <= pipelinesList.length"
          v-if="!this.$store.state.pipeline.creatingLoader"
          @click="() => this.$store.commit('NEW_PIPELINE_POPUP', true)"
          type="button"
          class="btn btn-primary"
        >
          <font-awesome-icon class="mr-3" size="lg" :icon="['fas', 'plus']" />
          New
        </button>
        <!-- <div :class="[' absolute top-0 mt-1 right-0 bg-gray-800 text-white p-2 rounded-md', ]" style="margin-right:-220px">
          Pipeline limit reached
        </div> -->
        <div v-if="this.$store.state.pipeline.creatingLoader">Loader ....</div>
      </div>
    </div>
    <!-- -------------------------------------------kanban board--------------------------  -->
    <section class="flex">
      <draggable
        :list="pipelineSegmentsDetails"
        class="flex list-group"
        group="people-1"
        @change="log"
      >
        <!-- all list  -->
        <div v-for="(segment, index) in pipelineSegmentsDetails" :key="index">
          <segment-card :segment="segment" />
        </div>
      </draggable>
      <section class="flex pr-12">
        <button
          type="button"
          class="btn btn-outline ml-5"
          @click="() => this.$store.commit('SEGMENT_LIST_POPUP', true)"
        >
          <font-awesome-icon class="mr-3" size="lg" :icon="['fas', 'plus']" />
          New
        </button>
      </section>
    </section>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
// import userInfo from '@/services/userInfo';
// import closeIcon from '@/components/icons/closeIcon.vue';
import NewPipelineModal from '@/components/pipeline/NewPipelineModal.vue';
import SegmentListModal from '@/components/pipeline/SegmentListModal.vue';
import NewSegmentModal from '@/components/pipeline/NewSegmentModal.vue';
import SegmentCard from '@/components/pipeline/SegmentCard.vue';
import PipelineEditModal from '@/components/pipeline/PipelineEditModal.vue';
import DeleteModal from '../../../components/Common/DeleteModal.vue';
import utils from '@/services/utils';
// import spinner from '@/components/spinner.vue';

export default {
  name: 'pipeline',
  layout: 'admin',
  order: 0,
  components: {
    draggable,
    NewPipelineModal,
    SegmentListModal,
    NewSegmentModal,
    SegmentCard,
    PipelineEditModal,
    DeleteModal,
  },
  data() {
    return {
      userInfo: null,
      userId: '',
      editModal: false,
      deleteModal: false,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.state.userDetails;
      },
      set(newData) {
        return newData;
      },
    },
    currentPipeline: {
      get() {
        return this.$store.state.pipeline.currentPipeline;
      },
      set(newName) {
        return newName;
      },
    },
    currentPipelineDetails: {
      get() {
        return this.$store.state.pipeline.currentPipelineDetails;
      },
      set(newName) {
        return newName;
      },
    },
    pipelinesList() {
      if (this.$store.state.pipeline.pipelinesList[0]) {
        this.$store.commit(
          'SET_CURRENT_PIPELINE',
          JSON.stringify(this.$store.state.pipeline.pipelinesList[0]),
        );
      }
      return this.$store.state.pipeline.pipelinesList;
    },
    pipelineSegmentsDetails() {
      return this.$store.state.pipeline.pipelineSegmentsDetails;
    },
    deleteSegmentLoader() {
      return this.$store.state.pipeline.deleteSegmentLoader;
    },
    pipelineLimit() {
      return this.$store.state?.userDetails?.myAccess?.pipelineLimit;
    },
  },
  async mounted() {
    // if (!this.user) {
    //   this.$store.dispatch('getMyDetails', {});
    // }
    console.log(this.user, 'this.user');
    await this.$store.dispatch('fetchPipelineData');
    this.$store.dispatch('getPipelineDetails');
    this.$store.dispatch('fetchCoursesList', this.user?.userId);
  },
  methods: {
    log() {
      this.$store.dispatch('changeSegmentOrder', {
        pipelineSegmentsDetails: this.pipelineSegmentsDetails.map(
          (events, index) => ({ segmentId: events?.courseInfo?.courseId, order: index }),
        ),
      });
      // console.log(evt, 'awds');
    },
    async deleteConfirmed() {
      try {
        this.deleteModal = false;
        this.$store.commit('toggleLoading', true);
        await this.$store.dispatch('deletePipeline', {});
        await this.$store.dispatch('fetchPipelineData');
        await this.$store.dispatch('getPipelineDetails');
        this.$store.commit('toggleLoading', false);
      } catch (error) {
        utils.setStatusMsg(this, error?.message || 'Something went wrong');
        this.$store.commit('toggleLoading', true);
      }
    },
  },
};
</script>
